export function normalizeUrl(input: string): string {
  try {
    const url = new URL(input);

    url.pathname = url.pathname.replace(/\/{2,}/g, "/");

    return url.toString();
  } catch {
    return input.replace(/([^:]\/)\/+/g, "$1");
  }
}
